import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  box-sizing: border-box;\n  cursor: ", ";\n  display: flex;\n  height: ", "px;\n  justify-content: center;\n  margin: 0;\n  opacity: ", ";\n  padding: ", "px;\n  width: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { color } from '@scp/ui-shared/theme/variables';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { LinkOrButton } from './LinkOrButton';
var ButtonElement = withRippleEffect(LinkOrButton);
var Button = styled(ButtonElement)(_templateObject(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.concise ? 40 : 48;
}, function (props) {
  return props.disabled ? 0.4 : 1;
}, function (props) {
  return props.concise ? 8 : 12;
}, function (props) {
  return props.concise ? 40 : 48;
});
/**
 * @example ./__docs__/IconButton.md
 */

export var IconButton = forwardRef(function (_a, ref) {
  var children = _a.children,
      title = _a.title,
      dataE2e = _a.dataE2e,
      darkBg = _a.darkBg,
      props = __rest(_a, ["children", "title", "dataE2e", "darkBg"]);

  return React.createElement(Button, Object.assign({
    type: "button",
    title: title,
    "aria-label": title,
    ref: ref,
    dataE2e: getE2eLabel(title, '', dataE2e),
    rippleColor: darkBg ? color.rippleOnDark : color.ripple
  }, props), children);
});